import React, { useState, useEffect } from "react";
import { FormHead, FormsControl, Buttons } from "./";
import style from "./profile.module.scss";
import ProfileService from "../../../service/profile";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import BankDetailsNotice from "./BankDetailsNotice";

function BankDetails(props) {
  console.log(props, "bank details");
  const { currentTheme } = useSelector((state) => state.Theme);
  const [data, setData] = useState(props.data);
  const [selectedBank, setSelectedBank] = useState(
    data.find((d) => d.code === "bankName")?.value || ""
  );
  const history = useHistory();

  useEffect(() => {
    const currentBankName =
      data.find((d) => d.code === "bankName")?.value || "";
    setSelectedBank(currentBankName);
  }, [data]);

  const changeHandler = (e) => {
    const { name, value } = e.target;

    setData((prevData) =>
      prevData.map((object) => {
        if (object.code === name) {
          let error = "";

          if (name === "accountNo") {
            if (value.length === 0) {
              error = `validation.${name}`;
            } else if (!/^\d+$/.test(value)) {
              error = "validation.not_allowed";
            }
          } else if (value.length === 0) {
            error = `validation.${name}`;
          }

          return {
            ...object,
            value: value,
            error: error,
          };
        }
        return object;
      })
    );
  };

  const changeDropDown = (key, id) => {
    setSelectedBank(key);

    setData((prevData) =>
      prevData.map((object) => {
        if (object.code === id.code) {
          return {
            ...object,
            value: key,
          };
        }
        return object;
      })
    );
  };

  const cancelButtonClick = () => {
    setData(props.data);
    props.cancelbtn();
  };

  const onSubmit = () => {
    let error = false;
    let formdata = {};
    data.forEach((element) => {
      if (element.error) {
        error = true;
      } else {
        formdata = {
          ...formdata,
          [element.code]: element.value,
        };
      }
    });

    if (!error) {
      if (
        formdata.bankName === "" ||
        formdata.accountNo === "" ||
        formdata.accountType === ""
      ) {
        props.showNotify(
          "danger",
          "error",
          "validation.checkValueYouHaveSubmitted"
        );
      } else {
        const service = new ProfileService();
        service.UpdateBankDetails(formdata).then((res) => {
          if (res.status) {
            if (res.data.status) {
              props.cancelbtn();
              props.updateSuccess(data, props.stateKey);
              props.showNotify(
                "success",
                "success",
                "profile." + res.data.message
              );
            }
          } else {
            let NewData;
            if (res.error.code === 1004) {
              NewData = data.map((obj) => {
                if (Object.keys(res.error.fields).includes(obj.code)) {
                  return {
                    ...obj,
                    error: "validation." + res.error.fields[obj.code],
                    errorField: {
                      ...obj,
                      field: obj.code,
                      length:
                        res.error.fields[obj.code + "_err"] === "min_length"
                          ? 3
                          : 32,
                    },
                  };
                }
                return obj;
              });
              setData(NewData);
              props.showNotify(
                "danger",
                "error",
                "validation.checkValueYouHaveSubmitted"
              );
            } else if (res.error.code === 1002) {
              history.push("/logout");
            }
          }
        });
      }
    }
  };

  return (
    <div
      className={`${
        currentTheme === "theme-dark"
          ? `${style.dark_mode_BankDetials}`
          : `${style.BankDetials}`
      }`}
    >
      <FormHead
        title="bankDetails"
        change={props.change}
        status={props.status}
        show={props.primary === false ? false : props.detailsDisable}
        detailsDisable={props.primary === false ? true : props.detailsDisable}
      />
      <BankDetailsNotice data={props.props.atmContent} />
      <div className={style.formControlsContainer}>
        {data.map((forms, index) => (
          <FormsControl
            extraDetails={props?.extraDetails}
            key={index}
            change={changeHandler}
            status={props.isEditable}
            data={forms}
            dropdownChange={changeDropDown}
          />
        ))}
      </div>
      {!props.isEditable && (
        <Buttons
          detailsDisable={props.primary === false ? true : props.detailsDisable}
          cancel={() => {
            cancelButtonClick();
          }}
          submitHandler={onSubmit}
        />
      )}
    </div>
  );
}

export default BankDetails;
